// External libs
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

// widget components
import WidgetTextBoxLarge from "./textBox/WidgetTextBoxLarge.js";

import { useDevice } from "../../hook/userDevice.js"

/**
 * A summary page card to display which use the WidgetTextBoxLarge to displays multiple rows of data for a device
 *
 * @param {string} deviceId - the device id of the device
 *
 * @returns {JSX.Element} The rendered device summary page
 *
 * @example
 * <WidgetDeviceSummary deviceId={selectedDevObj.id} />
 */
const WidgetDeviceSummary = ({ deviceId }) => {

  const { data: device, isLoading, error } = useDevice(deviceId);
  const [selectedDeviceText, setSelectedDeviceText] = useState(null);
  const [devName, setDevName] = useState(null);

useEffect(() => {
    const fields = [
      { key: "uuid", displayName: "UUID" },
      { key: "id", displayName: "ID" },
      { key: "name", displayName: "Name" },
      { key: "firmware", displayName: "Firmware" },
      { key: "hardware", displayName: "Hardware" },
      { key: "last_reboot", displayName: "Last Reboot" },
      { key: "reboot_reason", displayName: "Reboot Cause" },
      { key: "location", displayName: "Location" },
      { key: "connection_type", displayName: "Connection" },
      { key: "signal_strength", displayName: "Sig Strength" },
      { key: "memory_usage", displayName: "Memory" },
      { key: "debug_mode", displayName: "Debug Level" },
      { key: "in_service_date", displayName: "Date Added" },
    ];
    let rows = [];
    if (device == undefined) {
      setSelectedDeviceText(null);
      return;
    }
    fields.forEach((field) => {
      let row = { key: field.displayName };
      if (field.key in device) {
        row.value = device[field.key];
        if (field.key == "name")
        {
          setDevName(row.value);
        }
        if (field.key == "last_reboot") {
          const uptimeRow = {
            key: "Uptime",
            value: `${Math.round((new Date() - new Date(device[field.key])) / 1000)} (s)`,
          };
          rows.push(uptimeRow);
        }
      } else {
        row.value = "N/A";
      }
      rows.push(row);
    });
    setSelectedDeviceText(rows);
    console.log(rows);
  }, [device]);


  return (
          <WidgetTextBoxLarge
            header={devName}
            rows={selectedDeviceText}
          />  
  );
};

WidgetDeviceSummary.propTypes = {
  deviceId: PropTypes.string.isRequired
};

export default WidgetDeviceSummary;
